/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Playing_EyebrowInputs */

const en_about_playing_eyebrow = /** @type {(inputs: About_Playing_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Playing Career`)
};

const es_about_playing_eyebrow = /** @type {(inputs: About_Playing_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carrera como jugador`)
};

const de_about_playing_eyebrow = /** @type {(inputs: About_Playing_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spielerkarriere`)
};

const zh_about_playing_eyebrow = /** @type {(inputs: About_Playing_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`球员生涯`)
};

const ar_about_playing_eyebrow = /** @type {(inputs: About_Playing_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مسيرة اللعب`)
};

const fr_about_playing_eyebrow = /** @type {(inputs: About_Playing_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carrière de joueur`)
};

const vi_about_playing_eyebrow = /** @type {(inputs: About_Playing_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sự nghiệp thi đấu`)
};

const sw_about_playing_eyebrow = /** @type {(inputs: About_Playing_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Taaluma ya Uchezaji`)
};

const th_about_playing_eyebrow = /** @type {(inputs: About_Playing_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`อาชีพนักกอล์ฟ`)
};

const bs_about_playing_eyebrow = /** @type {(inputs: About_Playing_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Igračka karijera`)
};

const ja_about_playing_eyebrow = /** @type {(inputs: About_Playing_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`競技キャリア`)
};

const ko_about_playing_eyebrow = /** @type {(inputs: About_Playing_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`선수 경력`)
};

const pt_about_playing_eyebrow = /** @type {(inputs: About_Playing_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carreira como jogador`)
};

const it_about_playing_eyebrow = /** @type {(inputs: About_Playing_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carriera da giocatore`)
};

const sv_about_playing_eyebrow = /** @type {(inputs: About_Playing_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spelarkarriär`)
};

const nl_about_playing_eyebrow = /** @type {(inputs: About_Playing_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spelerscarrière`)
};

const da_about_playing_eyebrow = /** @type {(inputs: About_Playing_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spillerkarriere`)
};

const nb_about_playing_eyebrow = /** @type {(inputs: About_Playing_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spillerkarriere`)
};

const fi_about_playing_eyebrow = /** @type {(inputs: About_Playing_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pelaajaura`)
};

const pl_about_playing_eyebrow = /** @type {(inputs: About_Playing_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kariera zawodnicza`)
};

const ru_about_playing_eyebrow = /** @type {(inputs: About_Playing_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Игровая карьера`)
};

const tr_about_playing_eyebrow = /** @type {(inputs: About_Playing_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oyunculuk Kariyeri`)
};

const hi_about_playing_eyebrow = /** @type {(inputs: About_Playing_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`खिलाड़ी के रूप में करियर`)
};

const id_about_playing_eyebrow = /** @type {(inputs: About_Playing_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Karier Bertanding`)
};

const ms_about_playing_eyebrow = /** @type {(inputs: About_Playing_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kerjaya Bermain`)
};

const cs_about_playing_eyebrow = /** @type {(inputs: About_Playing_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hráčská kariéra`)
};

const el_about_playing_eyebrow = /** @type {(inputs: About_Playing_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Αγωνιστική καριέρα`)
};

const he_about_playing_eyebrow = /** @type {(inputs: About_Playing_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`קריירה כשחקן`)
};

const af_about_playing_eyebrow = /** @type {(inputs: About_Playing_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spelersloopbaan`)
};

const hu_about_playing_eyebrow = /** @type {(inputs: About_Playing_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Játékoskarrier`)
};

/**
* | output |
* | --- |
* | "Playing Career" |
*
* @param {About_Playing_EyebrowInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const about_playing_eyebrow = /** @type {((inputs?: About_Playing_EyebrowInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Playing_EyebrowInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_about_playing_eyebrow(inputs)
	if (locale === "de") return de_about_playing_eyebrow(inputs)
	if (locale === "zh") return zh_about_playing_eyebrow(inputs)
	if (locale === "ar") return ar_about_playing_eyebrow(inputs)
	if (locale === "fr") return fr_about_playing_eyebrow(inputs)
	if (locale === "vi") return vi_about_playing_eyebrow(inputs)
	if (locale === "sw") return sw_about_playing_eyebrow(inputs)
	if (locale === "th") return th_about_playing_eyebrow(inputs)
	if (locale === "bs") return bs_about_playing_eyebrow(inputs)
	if (locale === "ja") return ja_about_playing_eyebrow(inputs)
	if (locale === "ko") return ko_about_playing_eyebrow(inputs)
	if (locale === "pt") return pt_about_playing_eyebrow(inputs)
	if (locale === "it") return it_about_playing_eyebrow(inputs)
	if (locale === "sv") return sv_about_playing_eyebrow(inputs)
	if (locale === "nl") return nl_about_playing_eyebrow(inputs)
	if (locale === "da") return da_about_playing_eyebrow(inputs)
	if (locale === "nb") return nb_about_playing_eyebrow(inputs)
	if (locale === "fi") return fi_about_playing_eyebrow(inputs)
	if (locale === "pl") return pl_about_playing_eyebrow(inputs)
	if (locale === "ru") return ru_about_playing_eyebrow(inputs)
	if (locale === "tr") return tr_about_playing_eyebrow(inputs)
	if (locale === "hi") return hi_about_playing_eyebrow(inputs)
	if (locale === "id") return id_about_playing_eyebrow(inputs)
	if (locale === "ms") return ms_about_playing_eyebrow(inputs)
	if (locale === "cs") return cs_about_playing_eyebrow(inputs)
	if (locale === "el") return el_about_playing_eyebrow(inputs)
	if (locale === "he") return he_about_playing_eyebrow(inputs)
	if (locale === "af") return af_about_playing_eyebrow(inputs)
	if (locale === "hu") return hu_about_playing_eyebrow(inputs)
	return en_about_playing_eyebrow(inputs)
});